/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Citations_BodyInputs */

const en_why_listening_citations_body = /** @type {(inputs: Why_Listening_Citations_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening reads the prose without bracketed references, footnotes or the reference list, and keeps the sections navigable.`)
};

const es_why_listening_citations_body = /** @type {(inputs: Why_Listening_Citations_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening lee el texto sin referencias entre corchetes, notas al pie ni la lista de referencias, y mantiene las secciones navegables.`)
};

/**
* | output |
* | --- |
* | "Listening reads the prose without bracketed references, footnotes or the reference list, and keeps the sections navigable." |
*
* @param {Why_Listening_Citations_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_citations_body = /** @type {((inputs?: Why_Listening_Citations_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Citations_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_citations_body(inputs)
	return en_why_listening_citations_body(inputs)
});